import React, { useState, useContext, useEffect, use } from 'react';
import {
  Grid,
  Box,
  Button,
  TextField,
  Container,
  Typography,
  IconButton,
  InputAdornment,
} from '@mui/material';

import ClubHouseLogo from '../../assets/img/clubhouse_logo.png';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/Context';
import { useTranslation } from 'react-i18next';

import LoginIcon from '@mui/icons-material/Login';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

import { SocketContext } from '../../context/SocketContext';
import { SocketNFCContext } from '../../context/SocketNFC';

import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';

import ReceiptIcon from '@mui/icons-material/Receipt';
import NfcIcon from '@mui/icons-material/Nfc';

import ModalEmptyHall from '../Salgs/UserModals/ModalEmptyHall';
import ModalWrongKioskUser from './ModalWrongKioskUser';
import ModalTicketInfo from '../SalgsKiosk/Modals/ModalTicketInfo';
import ModalConfirmationPinKiosk from '../SalgsKiosk/Modals/ModalConfirmationPinKiosk';
import ModalPaperOutKiosk from '../SalgsKiosk/Modals/ModalPaperOutKiosk';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import English from '../../assets/img/english.png';
import Norsk from '../../assets/img/norsk.png';
import SampleIdleVideo from '../../assets/video/sample.mp4';
import IdleVideoOverlay from './IdleVideoOverlay';

import ModalPapirGameBatchResult from '../SalgsKiosk/Modals/Papir/ModalPapirGameBatchResult';
import ModalPapirGameNotFinished from '../SalgsKiosk/Modals/Papir/ModalPapirGameNotFinished';
import ModalPapirGameFinishedWithoutPrize from '../SalgsKiosk/Modals/Papir/ModalPapirGameFinishedWithoutPrize';
import ModalPapirGameFinishedWithPrize from '../SalgsKiosk/Modals/Papir/ModalPapirGameFinishedWithPrize';
import ModalPapirCheckCard from '../SalgsKiosk/Modals/Papir/ModalPapirCheckCard';
import ModalPapirTicketNotValid from '../SalgsKiosk/Modals/Papir/ModalPapirTicketNotValid';
import ModalPapirTicketNotSold from '../SalgsKiosk/Modals/Papir/ModalPapirTicketNotSold';

function LoginKiosk() {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const {
    showModalPapirGameBatchResult,
    showModalPapirTicketNotValid,
    showModalPapirTicketNotSold,
    showModalPapirGameNotFinished,
    showModalPapirGameFinishedWithoutPrize,
    showModalPapirGameFinishedWithPrize,
    showModalPapirCheckCard,
    showModalPaperOutKiosk,
    updateShowModalPaperOutKiosk,
    showModalConfirmPinKiosk,
    updateShowModalConfirmPinKiosk,
    updateKioskPaymentAccountEnabled,
    updateKioskPaymentCardEnabled,
    OKBingoID,
    ticketInfoKiosk,
    updateTicketInfoKiosk,
    updateShowModalTicketInfoKiosk,
    showModalTicketInfoKiosk,
    updatePapirScannedInfo,
    updateShowModalPapirGameBatchResult,
    updateShowModalPapirGameNotFinished,
    updateShowModalPapirGameFinishedWithoutPrize,
    updateShowModalPapirGameFinishedWithPrize,
    updateShowModalTicketPapirNotValid,
    updatePapirPrize,

    updateUserChildren,
    userLogin,
    parentInfo,
    updateIsLoginFromNfc,
    showModalWrongKioskUser,
    updateShowModalWrongKioskUser,
    updateIsSelfServiceKiosk,
    updateMaximumAnonPrizeAllowed,
    updateKiosk,
    updateIsPapirEnabled,
    updateIsPapirKingoEnabled,
    updateIsPapirXtippEnabled,
    updateIsSystemLockEnabled,
    isLogin,
    updateLogin,
    modifyOperator,
    updateSession,
    modifyOperatorFull,
    modifyOperatorInfo,
    modifyHall,
    updatePrinter,
    updateCardID,
    updateOKBingoID,
    updateIsOKBingoEnabled,
    updateIsNTEnabled,
    updateIsKioskEnabled,
    updateBingoID,
    updateIsEnabledBankID,
    updateIsWGEnabled,
    updateWGBingoID,
    updateIsAdmin,

    kioskHall,
    modifyKioskHall,
    updateShowModalEmptyHall,
    showModalEmptyHall,
    updateIsLoadingScreen,
    session,
    updateUserInfo,
    updateCurrentUser,
    updateCurrentUserID,
    updateUserLogin,

    WGBingoID,

    updatePrinterIP,
    printerIP,

    updateCloseTime,
  } = useContext(AppContext);

  var isLoading = false;

  const [showLogin, setShowLogin] = useState(false);
  const [pin, setPin] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [isGuest, setIsGuest] = useState(false);
  const [activeField, setActiveField] = useState('pin');
  const [showPinValue, setShowPinValue] = useState(false);
  const [showPhoneValue, setShowPhoneValue] = useState(false);
  const [idleActivitySignal, setIdleActivitySignal] = useState(0);

  const { socket } = useContext(SocketContext);
  const socketNFC = useContext(SocketNFCContext);

  useEffect(() => {
    if (!showModalConfirmPinKiosk) {
      setInfoFromBarcode(false);
      setInfoFromNFC(false);
    }
  }, [showModalConfirmPinKiosk]);

  const printerIPRef = React.useRef(printerIP);
  useEffect(() => {
    printerIPRef.current = printerIP;
  }, [printerIP]);

  useEffect(() => {
    if (!printerIP && kioskHall) {
      socket.emit('getPrinterConfig', { bingoName: kioskHall });
    }
  }, [kioskHall, printerIP, socket]);

  const isLoadingScreenRef = React.useRef(isLoading);
  useEffect(() => {
    isLoadingScreenRef.current = isLoading;
  }, [isLoading]);

  const OKBingoIDRef = React.useRef(OKBingoID);
  useEffect(() => {
    OKBingoIDRef.current = OKBingoID;
  }, [OKBingoID]);

  const ticketInfoKioskRef = React.useRef(ticketInfoKiosk);
  useEffect(() => {
    ticketInfoKioskRef.current = ticketInfoKiosk;
  }, [ticketInfoKiosk]);

  const WGBingoIDRef = React.useRef(WGBingoID);
  useEffect(() => {
    WGBingoIDRef.current = WGBingoID;
  }, [WGBingoID]);

  const [infoFromNFC, setInfoFromNFC] = useState(false);
  const infoFromNFCRef = React.useRef(infoFromNFC);
  useEffect(() => {
    infoFromNFCRef.current = infoFromNFC;
  }, [infoFromNFC]);

  const [infoFromBarcode, setInfoFromBarcode] = useState(false);
  const infoFromBarcodeRef = React.useRef(infoFromBarcode);
  useEffect(() => {
    infoFromBarcodeRef.current = infoFromBarcode;
  }, [infoFromBarcode]);

  const [infoFromBarcodeCH, setInfoFromBarcodeCH] = useState(false);
  const infoFromBarcodeCHRef = React.useRef(infoFromBarcodeCH);
  useEffect(() => {
    infoFromBarcodeCHRef.current = infoFromBarcodeCH;
  }, [infoFromBarcodeCH]);

  const [infoFromQrCH, setInfoFromQrCH] = useState(false);
  const infoFromQrCHRef = React.useRef(infoFromQrCH);
  useEffect(() => {
    infoFromQrCHRef.current = infoFromQrCH;
  }, [infoFromQrCH]);

  const [infoFromQrOKD, setInfoFromQrOKD] = useState(false);
  const infoFromQrOKDRef = React.useRef(infoFromQrOKD);
  useEffect(() => {
    infoFromQrOKDRef.current = infoFromQrOKD;
  }, [infoFromQrOKD]);

  const [infoFromQrWG, setInfoFromQrWG] = useState(false);
  const infoFromQrWGRef = React.useRef(infoFromQrWG);
  useEffect(() => {
    infoFromQrWGRef.current = infoFromQrWG;
  }, [infoFromQrWG]);

  useEffect(() => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost') {
      setPin('8010580');
      setPhonenumber('94036245');
    }
  }, []);

  const getUrlParameter = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  };

  const userLoginRef = React.useRef(userLogin);
  useEffect(() => {
    userLoginRef.current = userLogin;
  }, [userLogin]);

  const parentInfoRef = React.useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const isGuestRef = React.useRef(isGuest);
  useEffect(() => {
    isGuestRef.current = isGuest;
  }, [isGuest]);

  const pinRef = React.useRef(pin);
  useEffect(() => {
    pinRef.current = pin;
  }, [pin]);

  const phonenumberRef = React.useRef(phonenumber);
  useEffect(() => {
    phonenumberRef.current = phonenumber;
  }, [phonenumber]);

  //Check if hall param exists
  useEffect(() => {
    updateIsSelfServiceKiosk(true);
    const hallParam = getUrlParameter('hall');
    if (hallParam) {
      modifyKioskHall(hallParam);
      return;
    }
    updateShowModalEmptyHall(true);
  }, []);

  const kioskHallRef = React.useRef(kioskHall);
  useEffect(() => {
    kioskHallRef.current = kioskHall;
  }, [kioskHall]);

  useEffect(() => {
    if (!socket || !kioskHall || !printerIP) return;
    const hostname = window.location.hostname;
    if (hostname === 'localhost') return;

    socket.emit('checkPaperStatus', {
      bingoName: kioskHallRef.current,
      printerIP: printerIPRef.current,
    });

    const interval = setInterval(() => {
      socket.emit('checkPaperStatus', {
        bingoName: kioskHallRef.current,
        printerIP: printerIPRef.current,
      });
    }, 30000);

    return () => clearInterval(interval);
  }, [socket, kioskHall, printerIP]);

  const sessionRef = React.useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const incrementIpv4Address = (ipAddress) => {
    if (typeof ipAddress !== 'string') {
      return ipAddress;
    }

    const octets = ipAddress.split('.').map(Number);

    if (
      octets.length !== 4 ||
      octets.some((octet) => Number.isNaN(octet) || octet < 0 || octet > 255)
    ) {
      return ipAddress;
    }

    octets[3] = (octets[3] + 1) % 256;

    return octets.join('.');
  };

  useEffect(() => {
    const handleLoginKiosk = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        isLoading = false;
        toast.error(t('error.login'));
        return;
      }
      handleLoginOperator(data.operator, data.password);
    };

    const handleRegisterLogin = (data) => {
      if (data.schedule) {
        updateCloseTime(data.schedule.closeTime);
      }

      if (data.isEnabledBankID) {
        updateIsEnabledBankID(true);
      }

      if (data.isAdmin) {
        updateIsAdmin(true);
      } else {
        updateIsAdmin(false);
      }

      updateCardID(data.terminalID ?? '');

      for (var i = 0; i < data.bingoList.length; i++) {
        if (
          data.bingoList[i].bingoName === data.operatorInfo.hall.name &&
          data.bingoList[i].isEnabled
        ) {
          updateOKBingoID(data.bingoList[i].bingoID);
          updateIsOKBingoEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isWGEnabled.length; i++) {
        if (
          data.isWGEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isWGEnabled[i].isEnabled
        ) {
          updateWGBingoID(data.isWGEnabled[i].bingoID);
          updateIsWGEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isNTEnabled.length; i++) {
        if (
          data.isNTEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isNTEnabled[i].isEnabled
        ) {
          updateIsNTEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isPapirEnabled.length; i++) {
        if (
          data.isPapirEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isPapirEnabled[i].isEnabled
        ) {
          updateIsPapirEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isPapirKingoEnabled.length; i++) {
        if (
          data.isPapirKingoEnabled[i].bingoName ===
            data.operatorInfo.hall.name &&
          data.isPapirKingoEnabled[i].isEnabled
        ) {
          updateIsPapirKingoEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isPapirXtippEnabled.length; i++) {
        if (
          data.isPapirXtippEnabled[i].bingoName ===
            data.operatorInfo.hall.name &&
          data.isPapirXtippEnabled[i].isEnabled
        ) {
          updateIsPapirXtippEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isKioskEnabled.length; i++) {
        if (
          data.isKioskEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isKioskEnabled[i].isEnabled
        ) {
          updateIsKioskEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.resultPaymentMethodKiosk.length; i++) {
        if (
          data.resultPaymentMethodKiosk[i].bingoName ===
          data.operatorInfo.hall.name
        ) {
          updateKioskPaymentCardEnabled(
            data.resultPaymentMethodKiosk[i].isCardEnabled
          );
          updateKioskPaymentAccountEnabled(
            data.resultPaymentMethodKiosk[i].isAccountEnabled
          );
          break;
        }
      }

      updateKiosk(data.kiosk);
      updateMaximumAnonPrizeAllowed(data.maximumAnonPrizeAllowed);

      if (data.isSystemLockEnabled === 1) {
        updateIsSystemLockEnabled(true);
      }

      updateLogin(true);

      if (isGuestRef.current) {
        //navigate and guest user
        updateCurrentUser('4');
        updateUserLogin(true);
        updateUserInfo({ username: 'Gjest', firstname: 'Gjest' });
        updateIsLoadingScreen(false);
        navigate('/salgs-kiosk');
        return;
      }

      //If the nfc reader need to be triggered
      if (infoFromNFCRef.current) {
        updateIsLoginFromNfc(true);
        const memberDataToSearch = {
          auth_value: infoFromNFCRef.current,
          action: 'searchMember',
          session: sessionRef.current,
          searchByCard: true,
        };
        socket.emit('searchMemberMultiScan', memberDataToSearch);

        return;
      }

      if (infoFromBarcodeRef.current) {
        const memberDataToSearch = {
          auth_value: infoFromBarcodeRef.current,
          action: 'searchMember',
          session: sessionRef.current,
          searchByCardCH: true,
        };
        socket.emit('searchMemberMultiScan', memberDataToSearch);

        return;
      }

      if (infoFromBarcodeCHRef.current) {
        updateIsLoadingScreen(true);
        socket.emit('searchMemberKioskTicket', {
          auth_value: infoFromBarcodeCHRef.current,
          action: 'searchMember',
          session: sessionRef.current,
          searchByPin: true,
        });
        setInfoFromBarcodeCH(false);
        return;
      }

      if (infoFromQrCHRef.current) {
        updateIsLoadingScreen(true);
        socket.emit('searchMemberKioskTicket', {
          auth_value: infoFromQrCHRef.current,
          action: 'searchMember',
          session: sessionRef.current,
          searchByID: true,
        });

        setInfoFromQrCH(false);
        return;
      }

      if (infoFromQrOKDRef.current) {
        updateIsLoadingScreen(true);
        socket.emit('searchTicketOKD', {
          okID: infoFromQrOKDRef.current,
          action: 'searchTicketOKD',
          session: sessionRef.current,
          searchByID: true,
          bingoName: kioskHallRef.current,
        });

        setInfoFromQrOKD(false);
        return;
      }

      if (infoFromQrWGRef.current) {
        updateIsLoadingScreen(true);

        socket.emit('searchTicketWG', {
          wgID: infoFromQrWGRef.current,
          action: 'searchTicketWG',
          session: sessionRef.current,
          searchByID: true,
          bingoName: kioskHallRef.current,
          bingoID: WGBingoIDRef.current,
        });

        setInfoFromQrWG(false);
        return;
      }

      var data = {
        auth_value: pinRef.current,
        searchByPin: true,
        action: 'searchMember',
        session: sessionRef.current,
      };
      socket.emit('searchMemberMultiScan', data);

      //navigate('/salgs');
    };

    const handleSearchMemberMultiScan = (data) => {
      updateIsLoadingScreen(false);
      if (!data || !data.records) {
        updateShowModalWrongKioskUser(true);
        return;
      }

      if (data.records.length === 0) {
        updateShowModalWrongKioskUser(true);
        return;
      }

      if (infoFromNFCRef.current || infoFromBarcodeRef.current) {
        updateTicketInfoKiosk(data);
        updateShowModalConfirmPinKiosk(true);
        return;
      }

      updateUserLogin(true);
      updateUserInfo(data.records[0]);
      updateCurrentUser(data.records[0]['7 digit PIN']);
      updateCurrentUserID(data.records[0]['id']);
      if (data.children) {
        updateUserChildren(data.children);
      }

      updateIsLoadingScreen(false);
      navigate('/salgs-kiosk');
    };

    const handleSearchMember = (data) => {
      updateIsLoadingScreen(false);
      if (!data || !data.records) {
        updateShowModalWrongKioskUser(true);
        return;
      }

      if (data.records.length === 0) {
        updateShowModalWrongKioskUser(true);
        return;
      }

      if (
        data.records.length >= 1 &&
        String(data.records[0].mobile) === String(phonenumberRef.current)
      ) {
        updateUserLogin(true);
        updateUserInfo(data.records[0]);
        updateCurrentUser(data.records[0]['7 digit PIN']);
        updateCurrentUserID(data.records[0]['id']);

        if (data.children) {
          updateUserChildren(data.children);
        }

        updateIsLoadingScreen(false);
        navigate('/salgs-kiosk');
      } else {
        updateShowModalWrongKioskUser(true);
      }
    };

    //PAPIR HANDLERS
    const handleCheckPapirBatch = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirScannedInfo(data);
      updateShowModalPapirGameBatchResult(true);
    };

    const handleCheckPapirKingoBatch = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirScannedInfo(data);
      updateShowModalPapirGameBatchResult(true);
    };

    const handleCheckPapirCard = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isGameFinished && !data.hasTicketPrize) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isGameFinished && data.hasTicketPrize) {
        updatePapirPrize('pw');
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }

      return;
    };

    const handleCheckPapirKingoCard = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isGameFinished && !data.hasTicketPrize) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isGameFinished && data.hasTicketPrize) {
        updatePapirPrize('kingo');
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }

      return;
    };

    const handleCheckPapirXtippBatch = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirScannedInfo(data);
      updateShowModalPapirGameBatchResult(true);
    };

    const handleCheckPapirXtippCard = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isGameFinished && !data.hasTicketPrize) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isGameFinished && data.hasTicketPrize) {
        updatePapirPrize('xtipp');
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }

      return;
    };

    const handleSearchTicketOKD = (data) => {
      console.log('Received searchTicketOKD data:', data);
      if (!data) {
        toast.error(t('error.error'));
        updateIsLoadingScreen(false);
        return;
      }

      data.provider = 'okd';
      updateTicketInfoKiosk(data);

      socket.emit('ticketsOK', {
        operator: '',
        bingoName: kioskHallRef.current,
        userID: data.records[0].id,
        userInfo: data.records[0],
        session: sessionRef.current,
        action: 'ticketsOK',
        OKBingoID: OKBingoIDRef.current,
      });
    };

    const handleTicketsOK = (data) => {
      console.log('Received ticketsOK data:', data);

      if (data.error) {
        toast.error(t('error.error'));
        return;
      }

      //Ticket closed and no tickets open
      if (!data.ticketsOK) {
        updateIsLoadingScreen(false);
        updateTicketInfoKiosk('closed');
        updateShowModalTicketInfoKiosk(true);
        return;
      }

      //Several tickets, one still open
      for (let i = 0; i < data.ticketsOK.length; i++) {
        if (data.ticketsOK[i].okID === ticketInfoKioskRef.current.okID) {
          if (data.ticketsOK[i].isClosed) {
            let previousData = ticketInfoKioskRef.current;
            previousData.ticketsOK = data.ticketsOK;

            updateIsLoadingScreen(false);
            updateTicketInfoKiosk('closed');
            updateShowModalTicketInfoKiosk(true);
          }
          // ticket found and open — let handleBroadcastGetTicketSaldoOK handle it
          return;
        }
      }

      console.log('Not found, invalid ticket');

      updateIsLoadingScreen(false);
      updateTicketInfoKiosk('closed');
      updateShowModalTicketInfoKiosk(true);

      //updateTicketsOK(data.ticketsOK);
    };

    const handleBroadcastGetTicketSaldoOK = (data) => {
      console.log('Received broadcastGetTicketSaldoOK data:', data);
      if (data.error) {
        toast.error(t('error.error'));
        return;
      }

      if (
        data.ticketNumber &&
        data.ticketNumber === ticketInfoKioskRef.current.okID &&
        !data.errorDescription
      ) {
        let previousData = ticketInfoKioskRef.current;
        previousData.currentBalance = data.newSaldo;

        updateIsLoadingScreen(false);
        updateTicketInfoKiosk(previousData);
        updateShowModalTicketInfoKiosk(true);
      } else if (
        data.ticketNumber &&
        data.ticketNumber === ticketInfoKioskRef.current?.okID &&
        ((data.errorDescription &&
          (data.errorDescription.toLowerCase().includes('ticket er i bruk') ||
            data.errorDescription
              .toLowerCase()
              .includes('logget inn på maskin'))) ||
          (data.errorNumber && parseInt(data.errorNumber) === 510))
      ) {
        const usedData = { ...ticketInfoKioskRef.current, status: 'used' };
        updateIsLoadingScreen(false);
        updateTicketInfoKiosk(usedData);
        updateShowModalTicketInfoKiosk(true);
      }
    };

    const handleSearchTicketWG = (data) => {
      console.log('Received searchTicketWG data:', data);
      if (!data) {
        toast.error(t('error.error'));
        updateIsLoadingScreen(false);
        return;
      }

      if (data.ticket.isCashedOut || data.isExpired) {
        updateIsLoadingScreen(false);
        updateTicketInfoKiosk('closed');
        updateShowModalTicketInfoKiosk(true);
        return;
      }

      updateIsLoadingScreen(false);
      data.provider = 'wg';
      data.currentBalance = data.ticket.currentBalance;
      if (data.ticket.isInUse) {
        data.status = 'used';
      }
      updateTicketInfoKiosk(data);
      updateShowModalTicketInfoKiosk(true);
    };

    const handleSearchMemberKioskTicket = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        updateIsLoadingScreen(false);
        return;
      }

      updateIsLoadingScreen(false);

      data.provider = 'ch';
      data.currentBalance = data.records[0].balances.wallet;
      updateShowModalTicketInfoKiosk(true);
      updateTicketInfoKiosk(data);
    };

    const handleCheckPaperStatus = (data) => {
      if (!data) {
        updateShowModalPaperOutKiosk(false);
        return;
      }

      if (data.status === 'unknown' || data.nearEnd || data.paperEnd) {
        updateShowModalPaperOutKiosk(true);
      } else {
        updateShowModalPaperOutKiosk(false);
      }
    };

    const handleNewSellPapirTicket = (data) => {
      setIdleActivitySignal((prev) => prev + 1);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isTicketInUse) {
        updatePapirScannedInfo(data);
        updateShowModalTicketPapirNotValid(true);
        return;
      }

      if (data.isTicketInUse && !data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isTicketInUse && data.isGameFinished && data.win === 0) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isTicketInUse && data.isGameFinished && data.win > 0) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }
    };

    const handleGetPrinterConfig = (data) => {
      if (!data) return;
      updatePrinterIP(data.kiosk);
      updatePrinter({ text: '', name: '', id: '', ip: data.kiosk });
    };

    socket.on('getPrinterConfig', handleGetPrinterConfig);
    socket.on('loginKiosk', handleLoginKiosk);
    socket.on('registerLogin', handleRegisterLogin);
    socket.on('searchMemberMultiScan', handleSearchMemberMultiScan);
    socket.on('searchMember', handleSearchMember);

    socket.on('searchMemberKioskTicket', handleSearchMemberKioskTicket);

    socket.on('broadcastGetTicketSaldoOK', handleBroadcastGetTicketSaldoOK);
    socket.on('ticketsOK', handleTicketsOK);

    socket.on('checkPapirBatch', handleCheckPapirBatch);
    socket.on('checkPapirCard', handleCheckPapirCard);
    socket.on('checkPapirKingoCard', handleCheckPapirKingoCard);
    socket.on('checkPapirXtippCard', handleCheckPapirXtippCard);
    socket.on('checkPapirKingoBatch', handleCheckPapirKingoBatch);
    socket.on('checkPapirXtippBatch', handleCheckPapirXtippBatch);

    socket.on('searchTicketOKD', handleSearchTicketOKD);
    socket.on('searchTicketWG', handleSearchTicketWG);
    socket.on('checkPaperStatus', handleCheckPaperStatus);

    socket.on('newSalePapir', handleNewSellPapirTicket);

    return () => {
      socket.off('getPrinterConfig', handleGetPrinterConfig);
      socket.off('loginKiosk', handleLoginKiosk);
      socket.off('registerLogin', handleRegisterLogin);
      socket.off('searchMemberMultiScan', handleSearchMemberMultiScan);
      socket.off('searchMember', handleSearchMember);

      socket.off('searchMemberKioskTicket', handleSearchMemberKioskTicket);
      socket.off('checkPapirCard', handleCheckPapirCard);

      socket.off('checkPapirBatch', handleCheckPapirBatch);
      socket.off('checkPapirKingoCard', handleCheckPapirKingoCard);
      socket.off('checkPapirXtippCard', handleCheckPapirXtippCard);
      socket.off('checkPapirKingoBatch', handleCheckPapirKingoBatch);
      socket.off('checkPapirXtippBatch', handleCheckPapirXtippBatch);

      socket.off('broadcastGetTicketSaldoOK', handleBroadcastGetTicketSaldoOK);
      socket.off('ticketsOK', handleTicketsOK);

      socket.off('searchTicketOKD', handleSearchTicketOKD);
      socket.off('searchTicketWG', handleSearchTicketWG);
      socket.off('checkPaperStatus', handleCheckPaperStatus);

      socket.off('newSalePapir', handleNewSellPapirTicket);
    };
  }, [socket]);

  useEffect(() => {
    const handleCardDetected = (data) => {
      setIdleActivitySignal((prev) => prev + 1);

      if (isLoadingScreenRef.current) return;
      if (userLoginRef.current) {
        return;
      }

      if (
        parentInfoRef.current &&
        parentInfoRef.current.username.startsWith('hybrid')
      ) {
        return;
      }

      updateIsLoadingScreen(true);

      setInfoFromNFC(data);
      socket.emit('loginKiosk', {
        bingoName: kioskHallRef.current,
      });
    };

    const handleScannedXtippPapir = (data) => {
      setIdleActivitySignal((prev) => prev + 1);

      if (isLoadingScreenRef.current) return;
      updateIsLoadingScreen(true);

      const bingoName = kioskHallRef.current;
      const parts = data.split('|'); // ["PXT", ...]
      // Guard against bad scans
      if (parts.length < 3) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }

      if (parts[1] === 'B') {
        // Batch
        const code = parts[2];

        socket.emit('checkPapirXtippBatch', {
          code,
          bingoName,
        });
      } else {
        // Single card
        const ticketID = parts[1];
        const gameID = parts[2] ?? '';

        socket.emit('checkPapirXtippCard', {
          ticketID,
          bingoName,
          gameID,
        });
      }
    };

    const handleScannedKingoPapir = (data) => {
      setIdleActivitySignal((prev) => prev + 1);

      if (isLoadingScreenRef.current) return;
      //const bingoName = 'roulingo';
      const bingoName = kioskHallRef.current;
      const parts = data.split('|'); // ["PXT", ...]
      // Guard against bad scans
      if (parts.length < 3) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }

      if (parts[1] === 'B') {
        // Batch
        const code = parts[2];

        socket.emit('checkPapirKingoBatch', {
          code,
          bingoName,
        });
      } else {
        // Single card
        const ticketID = parts[1];
        const gameID = parts[2] ?? '';

        socket.emit('checkPapirKingoCard', {
          ticketID,
          bingoName,
          gameID,
        });
      }
    };

    const handleScannedBarcodeCard = (data) => {
      setIdleActivitySignal((prev) => prev + 1);

      if (isLoadingScreenRef.current) return;
      if (userLoginRef.current) {
        return;
      }

      if (
        parentInfoRef.current &&
        parentInfoRef.current.username.startsWith('hybrid')
      ) {
        return;
      }

      updateIsLoadingScreen(true);

      setInfoFromBarcode(data);
      socket.emit('loginKiosk', {
        bingoName: kioskHallRef.current,
      });
    };

    //Tickets come from handleScannerdQR (add extra logic) and handleScannedBarcode (need to be added entirely)
    const handleScannedQR = (data) => {
      setIdleActivitySignal((prev) => prev + 1);

      if (isLoadingScreenRef.current) return;
      if (!data.includes('qr.clubhouse.no')) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }
      const urlMatch = data.match(/https?:\/\/[^\s]+/);
      if (!urlMatch) {
        toast.error(t('sales.invalidTicketUrl'));
        updateIsLoadingScreen(false);
        return;
      }

      const url = new URL(data); // Parse the URL
      const params = new URLSearchParams(url.search); // Extract the query string

      // Prepare the data to be sent based on the parameters
      const dataToSearch = {};

      if (params.has('c') && params.has('p') && params.has('bn')) {
        const c = params.get('c');
        const p = params.get('p');
        const bn = params.get('bn');
        const bingoName = bn.replace(/_/g, ' ');
        if (bingoName !== kioskHallRef.current) {
          toast.error(t('sales.papirBatchInvalidHall'));
          updateIsLoadingScreen(false);
          return;
        }

        if (p === 'pw') {
          const b = params.get('b');
          if (b === 'true') {
            socket.emit('checkPapirBatch', {
              code: c,
              provider: p,
              bingoName: bingoName,
            });
          } else {
            const g = params.get('g');

            socket.emit('checkPapirCard', {
              ticketID: c,
              bingoName: bingoName,
              gameID: g,
            });
          }
        }
        if (p === 'kingo') {
          const b = params.get('b');
          if (b === 'true') {
            socket.emit('checkPapirKingoBatch', {
              code: c,
              bingoName: bingoName,
            });
          } else {
            const g = params.get('g');

            socket.emit('checkPapirKingoCard', {
              ticketID: c,
              bingoName: bingoName,
              gameID: g,
            });
          }
        }
        if (p === 'xtipp') {
          const b = params.get('b');
          if (b === 'true') {
            socket.emit('checkPapirXtippBatch', {
              code: c,
              bingoName: bingoName,
            });
          } else {
            const g = params.get('g');

            socket.emit('checkPapirXtippCard', {
              ticketID: c,
              bingoName: bingoName,
              gameID: g,
            });
          }
        }

        return;
      }

      if (params.has('okd')) {
        updateIsLoadingScreen(true);

        const okd = params.get('okd');
        setInfoFromQrOKD(okd);

        socket.emit('loginKiosk', {
          bingoName: kioskHallRef.current,
        });
      }

      if (params.has('wg')) {
        updateIsLoadingScreen(true);

        const wg = params.get('wg');
        console.log('WG ID from QR:', wg);
        setInfoFromQrWG(wg);

        socket.emit('loginKiosk', {
          bingoName: kioskHallRef.current,
        });
      }

      if (params.has('id')) {
        updateIsLoadingScreen(true);

        const memberId = params.get('id');
        setInfoFromQrCH(memberId);

        socket.emit('loginKiosk', {
          bingoName: kioskHallRef.current,
        });
      }
    };

    const handleScannedBarcode = (data) => {
      setIdleActivitySignal((prev) => prev + 1);

      if (isLoadingScreenRef.current) return;

      if (data.length !== 7) {
        return;
      }

      updateIsLoadingScreen(true);
      setInfoFromBarcodeCH(data);

      socket.emit('loginKiosk', {
        bingoName: kioskHallRef.current,
      });
    };

    const handleScannedPowerBingoPapir = (data) => {
      setIdleActivitySignal((prev) => prev + 1);
      updateIsLoadingScreen(true);

      //const bingoName = 'roulingo';
      const bingoName = kioskHallRef.current;
      const parts = data.split('|'); // ["PXT", ...]
      // Guard against bad scans
      if (parts.length < 3) {
        console.error('Invalid papir barcode:', data);
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }

      if (parts[1] === 'B') {
        // Batch
        const code = parts[2];

        socket.emit('checkPapirBatch', {
          code,
          bingoName,
        });
      } else {
        // Single card
        const ticketID = parts[1];
        const gameID = parts[2] ?? '';

        socket.emit('checkPapirCard', {
          ticketID,
          bingoName,
          gameID,
        });
      }
    };

    const handleNewPapirTicket = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      socket.emit('newSalePapir', {
        ticketID: data,
        bingoName: kioskHallRef.current,
        sessionID: '',
        operator: '',
        isCheck: true,
      });
    };

    socketNFC.on('scannedQR', handleScannedQR);
    socketNFC.on('scannedBarcode', handleScannedBarcode);

    socketNFC.on('cardDetected', handleCardDetected);

    socketNFC.on('scannedXtippPapir', handleScannedXtippPapir);
    socketNFC.on('scannedKingoPapir', handleScannedKingoPapir);

    socketNFC.on('scannedBarcodeCard', handleScannedBarcodeCard);

    socketNFC.on('scannedPapir', handleScannedPowerBingoPapir);
    socketNFC.on('scannedPowerBingoPapir', handleScannedPowerBingoPapir);
    socketNFC.on('newPapirTicket', handleNewPapirTicket);

    return () => {
      socketNFC.off('scannedQR', handleScannedQR);
      socketNFC.off('scannedBarcode', handleScannedBarcode);

      socketNFC.off('cardDetected', handleCardDetected);

      socketNFC.off('scannedXtippPapir', handleScannedXtippPapir);
      socketNFC.off('scannedKingoPapir', handleScannedKingoPapir);

      socketNFC.off('scannedBarcodeCard', handleScannedBarcodeCard);

      socketNFC.off('scannedPapir', handleScannedPowerBingoPapir);
      socketNFC.off('scannedPowerBingoPapir', handleScannedPowerBingoPapir);
      socketNFC.off('newPapirTicket', handleNewPapirTicket);
    };
  }, [socketNFC]);

  useEffect(() => {
    if (isLogin) {
      navigate('/salgs');
      return;
    }

    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        handleFormSubmit();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handleFormSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
  };

  const handleGuest = () => {
    //navigate('/salgs-kiosk');

    isLoading = true;
    updateIsLoadingScreen(true);
    setIsGuest(true);

    socket.emit('loginKiosk', {
      bingoName: kioskHallRef.current,
    });
  };

  const handleUserLogin = (e) => {
    e.preventDefault();

    if (phonenumberRef.current.length < 5 || pinRef.current.length < 7) {
      updateShowModalWrongKioskUser(true);
      return;
    }

    isLoading = true;
    updateIsLoadingScreen(true);
    console.log('emitting:', kioskHallRef.current);
    socket.emit('loginKiosk', {
      bingoName: kioskHallRef.current,
    });
  };

  const handleLoginOperator = async (username, password) => {
    if (isLoading) {
      return;
    }

    isLoading = true;
    updateIsLoadingScreen(true);

    let dataRequest = {
      username: username,
      password: password,
    };

    try {
      const hostname = window.location.hostname;
      var url = 'https://stage01-operator.vpfscandinavia.com';

      if (hostname === 'localhost') {
        url = 'https://stage01-operator.clubhouse.no/api/login';
      } else if (hostname.includes('stage01')) {
        url = 'https://stage01-operator.clubhouse.no/api/login/';
      } else if (hostname.includes('stage02')) {
        url = 'https://stage02-operator.clubhouse.no/api/login/';
      } else {
        url = 'https://operator.clubhouse.no/api/login/';
      }

      var response = await axios({
        method: 'post',
        url: url,
        data: dataRequest,
      });

      var dataPrint = {
        text: '',
        name: '',
        id: '',
        ip: printerIPRef.current,
      };
      updatePrinter(dataPrint);

      //const cookieString = response.headers["set-cookie"][0];
      //const sessValue = cookieString.split(";")[0].split("=")[1];

      const sessValue = response.data.operator.auth;
      response.data.session = sessValue;

      //Temp get countries
      //socket.emit("getCountries", response.data);

      if (!response) {
        isLoading = false;
        toast.error(t('error.login'));
        return;
      }

      updateSession(sessValue);
      modifyOperator(response.data.operator.username + ' - kiosk');
      modifyOperatorFull(response.data.operator.firstName);
      modifyHall(response.data.hall.name);
      modifyOperatorInfo(response.data);
      updateBingoID(response.data.hall.id);

      isLoading = false;

      var dataSocket = {
        operator: username,
        password: password,
        sessionID: sessValue,
        operatorInfo: response.data,
        platform: 'kiosk',
      };
      socket.emit('registerLogin', dataSocket);
    } catch (err) {
      console.error(err);
      isLoading = false;
      toast.error(t('error.login'));
      return;
    }
  };

  const handleComeBack = () => {
    setShowLogin(false);
    setPin('');
    setPhonenumber('');
  };

  const handleKeypadPress = (key) => {
    const isPhone = activeField === 'phonenumber'; // <- match your onFocus
    const setValue = isPhone ? setPhonenumber : setPin;
    const maxLen = 8;

    setValue((prev) => {
      if (key === 'clear') return '';
      if (key === 'back') return prev.slice(0, -1);
      if (prev.length >= maxLen && /^\d$/.test(key)) return prev;
      if (/^\d$/.test(key)) return prev + key;
      return prev;
    });
  };

  const keypadKeys = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'back',
    '0',
    'clear',
  ];

  return (
    <>
      <IdleVideoOverlay
        idleMs={30000}
        videoSrc={SampleIdleVideo}
        activitySignal={idleActivitySignal}
      />

      {showModalEmptyHall && <ModalEmptyHall />}
      {showModalWrongKioskUser && <ModalWrongKioskUser />}
      {showModalTicketInfoKiosk && <ModalTicketInfo />}
      {showModalConfirmPinKiosk && <ModalConfirmationPinKiosk />}
      {showModalPaperOutKiosk && <ModalPaperOutKiosk />}

      {showModalPapirTicketNotSold && <ModalPapirTicketNotSold />}

      {showModalPapirGameNotFinished && <ModalPapirGameNotFinished />}
      {showModalPapirGameFinishedWithPrize && (
        <ModalPapirGameFinishedWithPrize />
      )}
      {showModalPapirGameFinishedWithoutPrize && (
        <ModalPapirGameFinishedWithoutPrize />
      )}
      {showModalPapirCheckCard && <ModalPapirCheckCard />}
      {showModalPapirTicketNotValid && <ModalPapirTicketNotValid />}
      {showModalPapirGameBatchResult && <ModalPapirGameBatchResult />}

      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
          bgcolor: '#050505',
          gap: showLogin ? '24px' : '40px',
        }}
      >
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{ zIndex: 99999999 }}
        />

        {/* Language menu – top left */}
        <Box
          sx={{
            position: 'fixed',
            top: 24,
            left: 24,
            zIndex: 10,
          }}
        >
          <Box
            sx={{
              px: 2,
              pt: 1,
              pb: 1,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Grid
              container
              direction="row"
              spacing={1.5}
              sx={{ maxWidth: 180, gap: 3 }}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: 40,
                    height: 'auto',
                    cursor: 'pointer',
                  }}
                  alt="Norsk"
                  src={Norsk}
                  onClick={() => {
                    i18n.changeLanguage('no');
                    localStorage.setItem('language', 'no');
                  }}
                />
              </Grid>

              <Grid
                item
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: 40,
                    height: 'auto',
                    cursor: 'pointer',
                  }}
                  alt="English"
                  src={English}
                  onClick={() => {
                    i18n.changeLanguage('en');
                    localStorage.setItem('language', 'en');
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* Logo only on the first screen */}
        {!showLogin && (
          <Box
            sx={{
              animation: 'float 2.5s ease-in-out infinite',
              '@keyframes float': {
                '0%': { transform: 'translateY(0px)' },
                '50%': { transform: 'translateY(-10px)' },
                '100%': { transform: 'translateY(0px)' },
              },
            }}
          >
            <Box
              component="img"
              sx={{
                height: '600px', // slightly smaller for 1080x1920
                width: 'auto',
              }}
              alt=""
              src={ClubHouseLogo}
            />
          </Box>
        )}

        {/* Centered content (either tiles or form) */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            maxWidth: 600, // slightly narrower for 1080 width
          }}
        >
          {!showLogin ? (
            /* FIRST SCREEN: big tiles, slightly smaller than before */
            <Grid
              container
              direction="column"
              spacing={4}
              sx={{ width: '100%', gap: '40px' }}
            >
              <Grid item>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleGuest}
                  sx={{
                    height: 240,
                    borderRadius: '15px',
                    backgroundColor: '#2f49cf',
                    color: 'white',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: 32,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 14px 40px rgba(47, 73, 207, 0.5)',
                    transition:
                      'transform 0.2s, box-shadow 0.2s, background-color 0.2s',
                    '&:hover': {
                      backgroundColor: '#2f49cf', // keep it blue on hover
                      transform: 'translateY(-2px)',
                      boxShadow: '0 18px 50px rgba(47, 73, 207, 0.7)',
                    },
                    '&:active': {
                      backgroundColor: '#2f49cf', // also keep it blue when pressed
                      boxShadow: '0 10px 30px rgba(47, 73, 207, 0.6)',
                      transform: 'translateY(0)',
                    },
                  }}
                >
                  <PersonOutlineIcon sx={{ fontSize: 60, mb: 1 }} />
                  {t('login.guest')}
                </Button>
              </Grid>

              <Grid item>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => setShowLogin(true)}
                  sx={{
                    height: 240,
                    borderRadius: '15px',
                    backgroundColor: '#FFC727',
                    color: 'black',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: 32,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 14px 40px rgba(255, 199, 39, 0.55)',
                    transition:
                      'transform 0.2s, box-shadow 0.2s, background-color 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 18px 50px rgba(255, 199, 39, 0.75)',
                      bgcolor: '#FFD54F',
                    },
                  }}
                >
                  <LoginIcon sx={{ fontSize: 60, mb: 1 }} />
                  {t('login.login')}
                </Button>
              </Grid>
            </Grid>
          ) : (
            /* LOGIN FORM: compact for 1080x1920 but still touch-friendly */
            <form
              noValidate
              autoComplete="off"
              onSubmit={handleUserLogin}
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxWidth: '100%',
              }}
            >
              <Grid
                container
                direction="column"
                spacing={3}
                sx={{ gap: '40px' }}
              >
                {/* PIN FIELD (masked) */}
                <Grid item>
                  <TextField
                    autoFocus
                    label={t('kiosk.sevenDigitPin')}
                    variant="outlined"
                    value={pin}
                    onChange={(e) => {
                      const v = e.target.value.replace(/\D/g, '').slice(0, 7);
                      setPin(v);
                    }}
                    onFocus={() => setActiveField('pin')}
                    fullWidth
                    type={showPinValue ? 'text' : 'password'}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPinValue((prev) => !prev)}
                            edge="end"
                            sx={{ color: 'white', mr: 1 }}
                          >
                            {showPinValue ? (
                              <VisibilityOff fontSize="medium" />
                            ) : (
                              <Visibility fontSize="medium" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 130,
                        borderRadius: '15px',
                        '& fieldset': {
                          borderColor: '#2f49cf',
                        },
                        '&:hover fieldset': {
                          borderColor: '#2f49cf',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#2f49cf',
                          boxShadow: '0 12px 30px rgba(47, 73, 207, 0.45)',
                        },
                      },
                      '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                        color: 'white',
                        fontSize: 26,
                        top: '50%',
                        transform: 'translate(28px, -50%) scale(1)',
                      },
                      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                        transform: 'translate(20px, -9px) scale(0.9)',
                        fontSize: 20,
                        color: 'white',
                        backgroundColor: '#0f1320',
                        padding: '0 8px',
                      },
                      '& .MuiOutlinedInput-input': {
                        color: 'white',
                        fontSize: 40,
                        fontWeight: 500,
                        padding: '0 24px',
                        height: '100%',
                        boxSizing: 'border-box',
                      },
                    }}
                  />
                </Grid>

                {/* PHONE / PASSWORD FIELD (masked) */}
                <Grid item>
                  <TextField
                    label={t('kiosk.phonenumber')}
                    variant="outlined"
                    value={phonenumber}
                    onChange={(e) => {
                      const v = e.target.value.replace(/\D/g, '').slice(0, 13);
                      setPhonenumber(v);
                    }}
                    onFocus={() => setActiveField('phonenumber')}
                    fullWidth
                    type={showPhoneValue ? 'text' : 'password'}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPhoneValue((prev) => !prev)}
                            edge="end"
                            sx={{ color: 'white', mr: 1 }}
                          >
                            {showPhoneValue ? (
                              <VisibilityOff fontSize="medium" />
                            ) : (
                              <Visibility fontSize="medium" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 130,
                        borderRadius: '15px',
                        '& fieldset': {
                          borderColor: '#2f49cf',
                        },
                        '&:hover fieldset': {
                          borderColor: '#2f49cf',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#2f49cf',
                          boxShadow: '0 12px 30px rgba(47, 73, 207, 0.45)',
                        },
                      },
                      '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                        color: 'white',
                        fontSize: 26,
                        top: '50%',
                        transform: 'translate(28px, -50%) scale(1)',
                      },
                      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                        transform: 'translate(20px, -9px) scale(0.9)',
                        fontSize: 20,
                        color: 'white',
                        backgroundColor: '#0f1320',
                        padding: '0 8px',
                      },
                      '& .MuiOutlinedInput-input': {
                        color: 'white',
                        fontSize: 40,
                        fontWeight: 500,
                        padding: '0 24px',
                        height: '100%',
                        boxSizing: 'border-box',
                      },
                    }}
                  />
                </Grid>

                {/* KEYPAD */}
                <Grid item>
                  <Box
                    sx={{
                      mt: 1,
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      gap: 2,
                    }}
                  >
                    {keypadKeys.map((key) => (
                      <Button
                        key={key}
                        variant="contained"
                        onClick={() => handleKeypadPress(key)}
                        sx={{
                          height: 130,
                          borderRadius: '15px',
                          backgroundColor:
                            key === 'clear'
                              ? '#444'
                              : 'rgba(47, 73, 207, 0.95)',
                          color: 'white',
                          fontSize: key === 'back' || key === 'clear' ? 22 : 30,
                          fontWeight: 600,
                          boxShadow: '0 10px 30px rgba(47, 73, 207, 0.5)',
                          textTransform: 'none',
                          '&:hover': {
                            backgroundColor:
                              key === 'clear' ? '#555' : 'rgba(47, 73, 207, 1)',
                            boxShadow: '0 14px 40px rgba(47, 73, 207, 0.7)',
                          },
                        }}
                      >
                        {key === 'back'
                          ? '⌫'
                          : key === 'clear'
                            ? t('kiosk.clear') || 'Clear'
                            : key}
                      </Button>
                    ))}
                  </Box>
                </Grid>

                {/* LOGIN BUTTON */}
                <Grid item>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    sx={{
                      height: 220,
                      borderRadius: '15px',
                      bgcolor: '#FFC727',
                      color: '#000000',
                      fontWeight: 'bold',
                      fontSize: 28,
                      textTransform: 'uppercase',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 14px 40px rgba(255, 199, 39, 0.55)',
                      transition:
                        'transform 0.2s, box-shadow 0.2s, background-color 0.2s',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 18px 50px rgba(255, 199, 39, 0.75)',
                        bgcolor: '#FFD54F',
                      },
                    }}
                  >
                    <LoginIcon sx={{ fontSize: 60, mb: 1 }} />
                    {t('login.login')}
                  </Button>
                </Grid>

                {/* BACK */}
                <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      cursor: 'pointer',
                      color: '#6f82ff',
                      fontSize: 26,
                      textAlign: 'center',
                    }}
                    onClick={() => handleComeBack()}
                  >
                    {t ? t('login.back') : 'Back'}
                  </Typography>
                </Grid>
              </Grid>
            </form>
          )}
        </Box>

        {/* extra info scan (stays fixed at bottom) */}
        <Box
          sx={{
            position: 'fixed',
            bottom: 24,
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: 2,
          }}
        >
          {/* NFC */}
          <Box
            sx={{
              background: 'rgba(15, 19, 32, 0.85)',
              border: '1px solid rgba(111, 130, 255, 0.6)',
              borderRadius: '15px',
              px: 3,
              py: 1.25,
              display: 'flex',
              gap: 1.5,
              alignItems: 'center',
              boxShadow: '0 10px 35px rgba(0,0,0,0.35)',
              backdropFilter: 'blur(4px)',
              animation: 'pulse 2.5s ease-in-out infinite',
              '@keyframes pulse': {
                '0%': { boxShadow: '0 0 0 rgba(111,130,255,0.4)' },
                '50%': { boxShadow: '0 0 25px rgba(111,130,255,0.7)' },
                '100%': { boxShadow: '0 0 0 rgba(111,130,255,0.4)' },
              },
            }}
          >
            <NfcIcon sx={{ color: '#6f82ff', fontSize: 26 }} />
            <Typography
              sx={{ color: 'white', fontSize: 16, whiteSpace: 'nowrap' }}
            >
              {t('login.scan')}
            </Typography>
          </Box>

          {/* Ticket */}
          <Box
            sx={{
              background: 'rgba(15, 19, 32, 0.85)',
              border: '1px solid rgba(111, 130, 255, 0.6)',
              borderRadius: '15px',
              px: 3,
              py: 1.25,
              display: 'flex',
              gap: 1.5,
              alignItems: 'center',
              boxShadow: '0 10px 35px rgba(0,0,0,0.35)',
              backdropFilter: 'blur(4px)',
              animation: 'pulse 2.5s ease-in-out infinite',
              '@keyframes pulse': {
                '0%': { boxShadow: '0 0 0 rgba(111,130,255,0.4)' },
                '50%': { boxShadow: '0 0 25px rgba(111,130,255,0.7)' },
                '100%': { boxShadow: '0 0 0 rgba(111,130,255,0.4)' },
              },
            }}
          >
            <ReceiptIcon sx={{ color: '#6f82ff', fontSize: 26 }} />
            <Typography
              sx={{ color: 'white', fontSize: 16, whiteSpace: 'nowrap' }}
            >
              {t('login.ticket')}
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default LoginKiosk;
